import { PriceBox } from './price-box.component';
export * from './price-box.component';
export default PriceBox;

PriceBox.define('der-tailormade-roundtrip-offer-price-box');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-roundtrip-offer-price-box': PriceBox;
    }
}
